import { CurrentModuleOptions } from '../../../../constants-types';
import { ModuleName } from '../../../../core-data-model';

type V2ModuleData = {
    moduleName: ModuleName;
    v2ModuleStringName: string;
};

function getV2ModuleName(module: string): ModuleName {
    return ModuleName[module === 'Hire' ? 'HireHero' : module];
}

function transformModuleToV2String(module: string): string {
    return module === CurrentModuleOptions.Design ||
        module === CurrentModuleOptions.Inspire ||
        module === CurrentModuleOptions.Diagnose
        ? module + '2'
        : module;
}

export function getV2ModuleData(module: string): V2ModuleData {
    return {
        moduleName: getV2ModuleName(transformModuleToV2String(module)),
        v2ModuleStringName: transformModuleToV2String(module)
    };
}
